import React, { useState } from 'react';
import classNames from 'classnames/bind';
import SettingsMenu from '../SettingsMenu/SettingssMenu';
import styles from './MenuButton.module.scss';
import MainMenu from '../MainMenu/MainMenu';

const MenuButton = () => {
  const [open, setOpen] = useState(false);

  const boundStyles = classNames.bind(styles);

  const menuClasses = boundStyles({
    menu: true,
    open,
  });

  const overlayClasses = boundStyles({
    overlay: true,
    overlayOpen: open,
  });

  return (
    <>
    <div className={menuClasses} onClick={() => setOpen(!open)}>
      <div className={styles.bar1}></div>
      <div className={styles.bar2}></div>
      <div className={styles.bar3}></div>
    </div>

    <div className={overlayClasses}>
      <div className={styles.container}>
        <div className={styles.mainMenu}>
          <MainMenu styles={styles} close={() => setOpen(false)} />
        </div>
        <hr/>
        <div className={styles.settingsMenu}>
          <SettingsMenu close={() => setOpen(false)} styles={styles} />
        </div>
      </div>
    </div>
    </>
  )
}

export default MenuButton;
